import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DeclineReasonDialogData {
  reason: string;
  declinedBy: string;
  dateDeclined: Date | string;
}

@Component({
  selector: 'app-decline-reason-dialog',
  standalone: false,
  templateUrl: './decline-reason-dialog.component.html',
  styleUrl: './decline-reason-dialog.component.scss'
})
export class DeclineReasonDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeclineReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeclineReasonDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
